module.exports = __webpack_public_path__ + "img/pingdd.4d285892.png";